// extracted by mini-css-extract-plugin
export default {"backBtn":"iWXW6Jyx4RXdJu8iDHlB","backBtnEnd":"TRVZLvJZOdcL0iVHtUOW","infoIcon":"krgB0Wzu1R33uR87dWrT"};